import React from 'react';
import { makeStyles } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

import { useOrgData } from '../hooks/useOrgData';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

const useStyles = makeStyles((theme: HCPTheme) => ({
  logo: ({ top }: { top: boolean }) => ({
    ...(top
      ? {
          position: 'absolute',
          top: theme.spacing(1),
          left: '50%',
          transform: 'translateX(-50%)',
          maxWidth: '200px',
          maxHeight: '48px',
        }
      : {
          maxWidth: '200px',
          maxHeight: '64px',
        }),
  }),
}));

type Props = {
  top?: boolean;
};

export const CompanyLogo = ({ top = true }: Props) => {
  const { logo } = useStyles({ top });
  const {
    state: { token },
  } = useOnlineBookingReducer();
  const { data, isError } = useOrgData({ token });

  // if uuid is incorrect, response / logo_url will be empty
  if (!data?.logoUrl || isError) {
    return null;
  }

  return <img data-testid="company-logo" className={logo} src={data.logoUrl} alt="company logo" />;
};
